<template>
  <div class="row w-100 support-container no-gutters pt-4" v-if="checkForLoading">
    <div class="col-md-12 support-child-container">
      <div class="mr-1 d-inline-block font-italic" v-for="(supportObject,index) in supportList" :key="index">
        {{supportObject.title}}
        <strong>
          <a
            target="_blank"
            :href="supportObject.formattedSupportObj.url"
          >{{supportObject.formattedSupportObj.name}}</a>
        </strong> <span v-if="index < supportList.length -1"> or</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CONSTANTS from "@/store/constants";
export default {
  name: "Support",
  props: ["showSupportWhenLoading"],
  created() {
    if(!(this.currentAppData && this.currentAppData.supportList))
      this.getAppData(CONSTANTS.GUIDES_ALIAS)
  },
  computed: {
    supportList() {
      let formattedSupportList = [];
      if (this.currentAppData && this.currentAppData.supportList)
        this.currentAppData.supportList.forEach(support => {
          support.formattedSupportObj = JSON.parse(support.value);
          formattedSupportList.push(support);
        });
      return formattedSupportList;
    },
    checkForLoading() {
      if(this.showSupportWhenLoading) {
        return this.showSupportWhenLoading
      } else {
        return !this.isLoading
      }
    },
    ...mapGetters(["currentAppData", "isLoading"])
  },
  methods: {
    ...mapActions(["getAppData"]),
  }
};
</script>

<style scoped>

.support-child-container {
  margin-bottom: 30px;
}
</style>